import React from 'react';
import Helmet from 'react-helmet';
import Template from './template';

export default class PrivacyPolicy extends React.Component {
  render() {
    const title = 'Digital Millennium Copyright Act Notice';
    return (
      <Template title={title}>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title}/>
        </Helmet>

        <div>
          <p>
            The Digital Millennium Copyright Act of 1998 (the "DMCA") provides recourse for copyright owners who
            believe that material appearing on the Internet infringes their rights under U.S. copyright law. If you
            believe in good faith that materials appearing on our website or mobile application (collectively, the
            "Service") infringe your copyright, you (or your agent) may send us a notice requesting that the material
            be removed, or access to it blocked. <span style={{textDecoration: 'underline'}}>This notice must include</span>:
          </p>
          <br />
          <ol>
            <li>
              A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive
              right that is allegedly infringed.
            </li>
            <li>
              Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works
              at a single online site are covered by a single notification, a representative list of such works at that
              site.
            </li>
            <li>
              Identification of the material that is claimed to be infringing or to be the subject of infringing
              activity and that is to be removed or access to which is to be disabled, and information reasonably
              sufficient to permit the service provider to locate the
              material. <span style={{textDecoration: 'underline'}}>We will need direct URLs to the
              content/image(s) being referenced.</span> If URLs are not available, we will need screenshots.
            </li>
            <li>
              Information reasonably sufficient to permit the service provider to contact the complaining party, such as
              an address, telephone number, and, if available, an electronic mail address at which the complaining party
              may be contacted.
            </li>
            <li>
              A statement that the complaining party has a good faith belief that use of the material in the manner
              complained of is not authorized by the copyright owner, its agent, or the law.
            </li>
            <li>
              A statement that the information in the notification is accurate, and under penalty of perjury, that the
              complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly
              infringed.
            </li>
          </ol>
          <br />
          <p>
            In addition, if you believe in good faith that a notice of copyright infringement has been wrongly filed
            against you, the DMCA permits you to send us counter-notice. Notices and counter-notices must meet statutory
            requirements imposed by the DMCA. You acknowledge that if you fail to comply with all of the notice
            requirements of the DMCA, your notice may not be valid. One place to find more information is the U.S.
            Copyright Office Web site, currently located at <a href="http://www.loc.gov/copyright">http://www.loc.gov/copyright</a>.
          </p>
          <br />
          <p>
            In accordance with the DMCA, we have designated an agent to receive notification of alleged copyright
            infringement. Any written Notification of Claimed infringement should comply with Title 17, United States
            Code, Section 512(c)(3)(A) and should be provided in writing to our designated agent as follows:
          </p>
          <br />
          <p>
            NRT LLC<br />
            Attention: Office of the General Counsel<br />
            175 Park Avenue<br />
            Madison, NJ 07940<br />
          </p>
          <br />
          <p>
            e-mail: <a href="mailto:DMCAnotice@nrtllc.com">DMCAnotice@nrtllc.com</a>
          </p>
          <br />
          <p style={{ fontStyle: 'italic' }}>
            Please note: If you materially misrepresent that online material, product, or activity is infringing your
            copyrights, you may be liable for damages (including court costs and attorneys' fees) and could be subject
            to criminal prosecution for perjury. We suggest that you consult your legal advisor before filing a notice
            or counter-notice.
          </p>

        </div>
      </Template>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about-us/dmca.js